import { render, staticRenderFns } from "./ViaLocation.vue?vue&type=template&id=472627d2&scoped=true&"
import script from "./ViaLocation.vue?vue&type=script&lang=js&"
export * from "./ViaLocation.vue?vue&type=script&lang=js&"
import style0 from "./ViaLocation.vue?vue&type=style&index=0&id=472627d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472627d2",
  null
  
)

/* custom blocks */
import block0 from "./ViaLocation.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports